import React, { Fragment, useState } from "react";
import { Button } from 'antd';
import TranslatedText from "translations/TranslatedText";

export default function CheckAnswerButton(props) {
  const {
    checkAnswer,
    setCheckAnswer
  } = props;

  return (
    <Fragment>
      {
        !checkAnswer && (
          <Button onClick={()=>setCheckAnswer(true)}
                  type="primary"
          >
            <TranslatedText id="btn.checkit"/>
          </Button>
        )
      }
    </Fragment>
  )
};
